import { useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Linkedin, Send } from "lucide-react";
import { CATEGORIES } from "../lib/categories";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    try {
      const r = await api.post("/newsletter", { email: email.trim() });
      toast.success(r.data.already ? "Vous êtes déjà inscrit à notre infolettre." : "Merci ! Inscription confirmée, un e-mail de bienvenue vous a été envoyé.");
      setEmail("");
    } catch {
      toast.error("Adresse e-mail invalide.");
    }
  };

  return (
    <footer className="bg-[#0F172A] text-slate-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <h2 className="font-headline text-2xl font-black text-white">LE <span className="text-[#E11D48]">VÉRIDIQUE</span></h2>
          <p className="font-body text-sm text-slate-400 mt-3 leading-relaxed">
            Rien que vous rapporter ce qui est vrai. Votre source d'information indépendante et de référence.
          </p>
          <div className="flex gap-3 mt-4">
            {[Facebook, Twitter, Instagram, Linkedin].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#E11D48] transition-colors" data-testid={`footer-social-${i}`}>
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="meta-label text-white mb-4">Rubriques</h3>
          <ul className="space-y-2">
            {CATEGORIES.filter((c) => !c.featuredPage).map((c) => (
              <li key={c.slug}>
                <Link to={`/rubrique/${c.slug}`} className="font-sub text-sm text-slate-400 hover:text-white">{c.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="meta-label text-white mb-4">Le journal</h3>
          <ul className="space-y-2 font-sub text-sm text-slate-400">
            <li><a href="#" className="hover:text-white">À propos</a></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-white">Contact</Link></li>
            <li><Link to="/faq" data-testid="footer-faq-link" className="hover:text-white">FAQ – Foire aux questions</Link></li>
            <li><a href="#" className="hover:text-white">Mentions légales</a></li>
            <li><a href="#" className="hover:text-white">Politique de confidentialité</a></li>
          </ul>
        </div>

        <div>
          <h3 className="meta-label text-white mb-4">Infolettre gratuite</h3>
          <p className="font-body text-sm text-slate-400 mb-3">Abonnez-vous gratuitement et recevez l'essentiel de l'actualité par e-mail.</p>
          <form onSubmit={subscribe} className="flex gap-2">
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Votre e-mail"
              data-testid="newsletter-input"
              className="flex-1 bg-white/10 rounded px-3 py-2 text-sm font-sub text-white placeholder:text-slate-500 outline-none focus:ring-1 focus:ring-[#E11D48]" />
            <button type="submit" data-testid="newsletter-submit" className="bg-[#E11D48] px-3 rounded flex items-center justify-center"><Send size={16} /></button>
          </form>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2">
          <span className="meta-label text-slate-500">© 2026 Le Véridique — Tous droits réservés</span>
          <span className="meta-label text-slate-500">Fait avec passion pour l'information</span>
        </div>
      </div>
    </footer>
  );
}
